import React from 'react'
import cx from "classnames";
import styles from "../InputToolbar/InputToolbar.module.scss";
import LayerSwitch from "../LayerSwitch";
import DeleteUserInputButton from "../DeleteUserInputButton";
import {StoredSpot} from "../../../../types/Individualization";

type InputToolbarProps = {
    spot: StoredSpot
    unique_id: string
    onDelete?: (unique_id: string) => void
}

const InputToolbar: React.FC<InputToolbarProps> = ({ unique_id, onDelete, spot }) => {
    return (
        <div className={cx(styles['input-button-wrapper'])}>
            <LayerSwitch unique_id={unique_id} />
            <DeleteUserInputButton
                unique_id={unique_id}
                onDelete={onDelete}
                spot_id={spot.id}
            />
        </div>
    )
}

export default InputToolbar